import { LitElement, html, css } from 'lit';
import { accessibility, grid, formStyles } from '../../utilities/styles';
import { arrowBack } from '../../utilities/icons';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInMemberConsumer } from '../Utilities/AllInMemberConsumer';
import { AllInMembersBase } from '../Utilities/AllInMembersBase';
import { addIcon } from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInMemberShareProfile extends AllInSessionStorage(AllInMemberConsumer(AllInMembersBase(LitElement))) {
    static properties = {
        name: { type: String },
        loading: { type: Boolean, state: true },
        _formResponse: { type: String, state: true },
        _showAddScreen: { type: Boolean, state: true },
        accessOrgs: { type: Array, state: true },
        _actionLinks: { type: String, state: true },
        _actionLinksName: { type: String, state: true },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        let accessOrgs = this.membership.organisationShares;
        if (accessOrgs.length > 0) {
            this.accessOrgs = accessOrgs;
        }
        if (this.accessOrgs) {
            this._fetchAccess();
        }
        else {
            await this._fetchAccess();
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('membership')) {
            this.accessOrgs = this.membership?.organisationShares;
        }
    }
    render() {
        let main = '';
        if (this.loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            if (this._actionLinks) {
                main = html `<div class="action-links bg">\n                    <h3>${this._actionLinksName ? this._actionLinksName : ''} action required </h3>\n                    <p>${this._actionLinksName ? this._actionLinksName : 'This organisation'} is requesting an external link to complete sharing your profile</p>\n                    <a href="${this._actionLinks}" class="button">Complete sharing your profile</a>\n                </div>`;
            }
            else if (this._showAddScreen) {
                main = html `<h3>Add an organisation</h3>\n                <form class="bg" @submit=${this._handleAddOrg}>\n                    <div class="message ${this._formResponse ? 'error' : ''}" aria-live="polite">${this._formResponse}</div>\n                    <allin-organisation-search name="addMemberOrgSearch" resturl="${this.restUrl}" members nonce="${this.nonce}" .exclusions=${this.accessOrgs?.map(org => org.organisationId)}></allin-organisation-search>\n                </form>\n                <button class="cancel" @click=${() => this._showAddScreen = false}><span aria-hidden="true">${arrowBack}</span>Back to all shared organisations</button>\n                `;
            }
            else if (!this.accessOrgs) {
                main = html `\n                    <h3>Who has access to my profile</h3>\n                    <div class="dashboard-flavour-text">\n                        <p>Search for organisations you will be visiting and share your access profile with them before you book. You have control over which organisations can see your details, and you can revoke their access at any time.</p>\n                    </div>\n                    <div class="bg">\n                        <p>You haven't shared your profile with any organisations yet.</p>\n                        <button class="cta" @click=${() => this._showAddScreen = true}>Add organisation</button>\n                    </div>\n                `;
            }
            else {
                main = html `\n                    <ul title="Who has access to my profile">\n                        ${this.accessOrgs.map((org) => {
                    let button = html `<button @click=${() => this._removeOrg(org.id)}>Remove access</button>`;
                    let name = org.orgName ?? org.name;
                    return html `\n                                <li>\n                                    <div class="content">\n                                        <p><strong>Name</strong></p>\n                                        <p>${name}</p>\n                                    </div>\n                                    <div class="buttons">\n                                        ${button}\n                                    </div>\n                                </li>\n                            `;
                })}\n                            <button @click=${() => this._showAddScreen = true}><span aria-hidden="true">${addIcon}</span>Share with a new organisation</button>\n                    </ul>\n                `;
            }
        }
        return html `\n            <div class="group-container">\n                ${main}\n            </div>\n        `;
    }
    _hidePanel(e) {
        e.preventDefault();
        this._updateContext({ panel: '' });
    }
    async _handleAddOrg(e) {
        e.preventDefault();
        this.loading = true;
        const input = e.target.querySelector('input');
        this._formResponse = '';
        const orgId = input.value;
        let response = await fetch(`${this.restUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
            },
            body: JSON.stringify({ 'action': `${this.action}-add-shared-org`, 'org_to_add': orgId, }),
        });
        if (response.status === 403) {
            handle403s();
            return;
        }
        let data = await response.json();
        if (data.ok) {
            if (data.action_links) {
                this._actionLinks = data.action_links;
                this._actionLinksName = data.action_links_name;
            }
            else {
                this._showAddScreen = false;
            }
            this.membership = data.membership;
            this._updateContext({ membership: this.membership });
            this.loading = false;
        }
        else {
            this.loading = false;
            this._formResponse = data.message;
        }
    }
    async _fetchAccess() {
        this.loading = true;
        let url = `${this.restUrl}?action=get_shared_orgs&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            let data = await response.json();
            this.accessOrgs = data.orgs;
            if (this.accessOrgs) {
                this.membership.organisationShares = this.accessOrgs;
                this._updateContext({ membership: this.membership });
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
        this.loading = false;
    }
    async _removeOrg(orgId) {
        this.loading = true;
        let response = await fetch(`${this.restUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
            },
            body: JSON.stringify({ 'action': `${this.action}-remove-shared-org`, 'org_to_remove': orgId }),
        });
        let data = await response.json();
        if (data.ok) {
            this._showAddScreen = false;
            this.membership = data.membership;
            this._updateContext({ membership: this.membership });
            this.loading = false;
        }
        else {
            this.loading = false;
            this._formResponse = data.message;
        }
    }
    static styles = [
        accessibility,
        grid,
        formStyles,
        css `
        .group-container{
            margin-bottom:2rem;
        }
        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
            font-weight:var(--allin-highlight-weight,700);
            cursor:pointer;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        .cta{
            margin-top:1rem;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }

         allin-organisation-search .bg{
            background-color:var(--color-bg);
        }
        allin-organisation-search ul{
            list-style:none;
            padding:0;
            margin:1rem 0;
        }
        allin-organisation-search ul li{
            margin-bottom:0.5rem;
            display:grid;
            grid-template-columns: 3rem 1fr auto;
            gap:1rem;
            align-items:center;
            padding-left: 1rem;
            img{
                width:3rem;
                height:3rem;
                object-fit:cover;
            }
            button{
                height:fit-content;
            }
            p{
                grid-column:1/-1;
            }
        }
        allin-organisation-search ul li img{
            width:3rem;
            height:3rem;
            object-fit:cover;
        }
        allin-organisation-search ul li button{
            height:fit-content;
        }
        .searchboxes {
            display: grid;
            grid-template-columns: 1fr auto;
            width: 100%;
            max-width: 800px;
            margin-bottom: 2rem;
            position:relative;
        }

        .searchbox {
            position: relative;
            label {
                margin-bottom: 0.5rem;
            }
        }
        .searchbox svg {
            position: absolute;
            left: 0.5rem;
            bottom: 0.8rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .searchbox input{
            padding-left:2.5rem;
            border-radius:0.5rem 0 0 0.5rem;
        }
        .searchboxes button{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }

         ul{
            list-style:none;
            padding:0;
            margin:0;
            background-color:var(--allin-white-color,#fff);
            border:1px solid var(--allin-border-color,#000);
            padding:2rem;
            margin-bottom:2rem;
        }

        ul li{
            display:grid;
            grid-template-columns:4fr 3fr 3fr;
            font-size:0.9rem;
        }

        ul+ul{
            margin-top:2rem;
        }

        .content p{
            margin-bottom:0.5rem;
        }

        .content p:has(>strong){
            margin-bottom:0.1rem;
        }

        ul li:first-of-type{
            padding-top: 1.5rem;
        }
        ul li:last-of-type{
            padding-bottom: 0.5rem;
        }
        ul li + li{
            border-top:1px solid var(--allin-border-color,#000);
            padding-top:1.5rem;
            margin-top:1rem
        }

        ul button,.cancel{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            height:fit-content;
            padding:0;
            font-weight:700;
            text-decoration:underline;
            font-size:0.9rem;
            display:flex;
            gap:0.5rem;
            align-items:center;
            padding:0;
            text-align:left;
        }

        ul button span:not(.resend, .resent), .cancel span{
            display:flex;
            align-items:center;
            width:1.2rem;
        }

        ul button svg, .cancel svg{
            transition:transform var(--transition) ease;
            width:1.2rem;
        }

        ul button:hover, .cancel:hover{
            text-decoration-thickness:2px;
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            font-weight:700;
        }

        ul button:hover svg, .cancel:hover svg{
            transform:rotate(5deg);
        }

        li:has(+button){
            border-bottom:1px solid var(--allin-border-color,#000);
            padding-bottom:1.5rem;
            margin-bottom:1rem
        }

        li a{
            color:var(--allin-text-color,#000);
            word-break:break-all;
            
        }

        li a:hover{
            text-decoration-thickness:1.2px;
        }

        li>*nth-child(2){
           padding:0 1rem;
        }

        li>*:nth-child(3){
            justify-self:end;
            padding-right:1rem;
        }
        .invite-status{
            font-weight:700;
        }

        .invite-status.invited{
            color:var(--allin-disable-color,#707070);
        }
        `
    ];
}
